'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { VisuallyHidden } from '../visually-hidden/visually-hidden';
import { LoadingMaskRootContext } from './context/loading-mask-root.context';
import { loadingMaskRootStyles } from './styles/loading-mask-root.styles';
import type { LoadingMaskPropsInterface } from './types/loading-mask.types';

export const LoadingMaskRoot = forwardRef<HTMLDivElement, LoadingMaskPropsInterface>(
  (props: LoadingMaskPropsInterface, forwardedRef) => {
    const {
      children,
      className,
      css: cssProp,
      iconSize = 'lg',
      loading = true,
      loadingVoiceOver = 'Loading',
      onImpact = false,
      role = 'status',
      ...rest
    } = props;

    const styles = css(loadingMaskRootStyles, cssProp);

    return (
      <LoadingMaskRootContext.Provider value={{ loading, iconSize, onImpact }}>
        <div
          className={cx('c11n', styles, className)}
          data-c11n-component="LoadingMask.Root"
          data-c11n-version={__C11N_VERSION__}
          ref={forwardedRef}
          role={role}
          {...rest}
        >
          {loading ? <VisuallyHidden>{loadingVoiceOver}</VisuallyHidden> : null}
          {children}
        </div>
      </LoadingMaskRootContext.Provider>
    );
  },
);

LoadingMaskRoot.displayName = 'LoadingMask.Root';
